import React from 'react'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners'
import {FormattedMessage as T} from 'react-intl'

// If you need more than a Cancel/Confirm, don't use this
export const ConfirmationDialog = ({
  title,
  danger,
  children,
  onConfirm,
  confirmText,
  showCancel,
  cancelText,
  onCancel,
  onRequestClose,
  confirmPending,
  footerHint,
  ...props
}) => (
  <ModalOverlay
    title={title}
    maxWidth='500px'
    onRequestClose={onRequestClose}
    footer={<Footer
      danger={danger}
      onConfirm={onConfirm}
      confirmPending={confirmPending}
      confirmText={confirmText || <T id='ConfirmationDialog.confirmText' defaultMessage='Confirm' />}
      showCancel={showCancel}
      cancelText={cancelText || <T id='ConfirmationDialog.cancelText' defaultMessage='Cancel' />}
      onCancel={onCancel}
      hint={footerHint} />}
    {...props}>
    {children}
  </ModalOverlay>
)

ConfirmationDialog.defaultProps = {
  showCancel: true,
  danger: false
}

const Footer = ({onConfirm, onCancel, confirmText, showCancel, cancelText, confirmPending, danger, hint}) => (
  <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
    {hint && <div>{hint}</div>}
    {/* IE11 prefers this over "marginRight: auto" in the hint div */}
    {hint && <div style={{flexGrow: 1}} />}
    {showCancel && <a style={{margin: '0 30px 0 0', fontWeight: 500}} onClick={onCancel}>
      {cancelText}
    </a>}
    <CTA primary inline danger={danger} style={{margin: '0 0'}} disabled={!!confirmPending} onClick={confirmPending ? null : onConfirm}>
      {confirmPending && <CircleSpinner size={14} />} {confirmText}
    </CTA>
  </div>
)
